// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuColumnNameLabel-calculated{cursor:pointer;gap:2px;display:flex}.vuuColumnNameLabel-edit{margin-left:auto}.vuuColumnNameLabel-placeholder{color:var(--vuu-color-gray-35)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
